import { get, getBaseSchedulerTitle, isEmpty, normalizeSchedulers } from '@/utils/helpers';
import { CANCEL_CONSULTATION, CREATE_CONSULTATION, UPDATE_CONSULTATION } from '../consultations/consultationsActionsTypes';
import {
  ADD_SCHEDULES,
  DELETE_SCHEDULE,
  FETCH_SCHEDULERS,
  UPDATE_SCHEDULE,
} from './types';
import { CLEAR_PAGE } from '../base/types';
import { CONSULTATIONS_STATUSES } from '@/configs';

const PSYCHOLOGIST_TYPE = 'psychologist';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const schedulersReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_SCHEDULERS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_SCHEDULERS}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_SCHEDULERS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case ADD_SCHEDULES:
    case `${ADD_SCHEDULES}_FULFILLED`:
      return {
        ...state,
        data: [...state.data, ...(payload || [])],
      };

    case `${UPDATE_SCHEDULE}_FULFILLED`:
      return {
        ...state,
        data: state.data.map((item) => {
          if (item?.id?.toString() === payload?.id?.toString()) {
            return payload;
          }
          return item;
        }),
      };

    case `${DELETE_SCHEDULE}_FULFILLED`:
      return {
        ...state,
        data: state.data.filter(
          (i) => i?.id?.toString() !== payload?.id?.toString()
        ),
      };

    case `${UPDATE_CONSULTATION}_FULFILLED`:
      if (isEmpty(state.data) || !payload?.fromSheduleId) return state;
      return {
        ...state,
        data: get(state, ['data'], []).map((i) => {
          if (Number(i.id) === Number(payload?.fromSheduleId)) {
            return {
              ...i,
              taken: false,
              user_name: null,
              user_id: null,
              consultation_id: null,
              consultation_status: null,
              classNames: '',
              title: getBaseSchedulerTitle({
                ...i,
                user_name: null,
                user_id: null,
              }),
            };
          }
          if (Number(i.id) === Number(payload?.schedule?.id)) {
            const specialist_name = payload?.psychologist?.fullname;
            const user_name = payload?.user?.fullname;
            return {
              ...normalizeSchedulers({
                ...payload?.schedule,
                specialist_name,
                specialist_type: PSYCHOLOGIST_TYPE,
                user_name,
              }),
              psychologist: payload?.psychologist?.id,
              specialist_name,
              specialist_type: PSYCHOLOGIST_TYPE,
              user_name,
              user_id: payload?.user?.id,
              consultation_id: payload?.id,
              consultation_status: payload?.status,
              taken: true,
            };
          }
          return i;
        }),
      };

    case `${CANCEL_CONSULTATION}_FULFILLED`:
      if (isEmpty(state.data) || !payload?.scheduleId) return state;
      return {
        ...state,
        data: get(state, ['data'], []).map((i) => {
          if (Number(i.id) === Number(payload?.scheduleId)) {
            const item = {
              ...i,
              taken: false,
              user_name: null,
              user_id: null,
              consultation_id: null,
              consultation_status: CONSULTATIONS_STATUSES.canceled,
              classNames: 'event-canceled',
            };
            return {
              ...item,
              title: getBaseSchedulerTitle(item),
            };
          }
          return i;
        }),
      };

    case `${CREATE_CONSULTATION}_FULFILLED`:
      if (isEmpty(state.data) || !payload?.schedule.id) return state;
      return {
        ...state,
        data: get(state, ['data'], []).map((i) => {
          if (Number(i.id) === Number(payload?.schedule?.id)) {
            return {
              ...normalizeSchedulers({
                ...payload?.schedule,
                specialist_name: payload?.psychologist?.fullname,
                specialist_type: PSYCHOLOGIST_TYPE,
                user_name: payload?.user?.fullname,
              }),
              taken: true,
              user_id: payload?.user?.id,
              consultation_id: payload?.id,
              consultation_status: payload?.status,
            };
          }
          return i;
        }),
      };

    case CLEAR_PAGE:
      return payload === 'schedulers' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default schedulersReducer;
